import { memo } from 'react'
import { getCheckedValue } from '../../../Helpers/Util'

interface IRadioComponent {
  classes?: string
  inputId: string | number
  value: string
  name?: string
  checked?: boolean | 'undefined'
  disabled?: boolean
  onChange: () => void
  dataTestId?: string
}
const RadioInputComponent: React.FC<IRadioComponent> = ({
  classes,
  checked,
  inputId,
  name,
  onChange,
  value,
  dataTestId,
  disabled,
}: IRadioComponent) => {
  return (
    <div className={`replace-asset-radio ${classes ?? ''}`}>
      <input
        type='radio'
        id={inputId?.toString()}
        value={value}
        name={name ?? 'assetRadioGroup'}
        checked={getCheckedValue(checked)}
        disabled={disabled}
        onChange={onChange}
        className='cursor-pointer'
        data-testid={dataTestId ?? `radio-${inputId}`}
      />
      <label htmlFor={inputId?.toString()}>
        <span style={{ visibility: 'hidden' }}>{inputId}</span>
      </label>
    </div>
  )
}

export default memo(RadioInputComponent)
